import { SiteConfig } from "../../types";

export const _config: SiteConfig = {
  isDefault: false,
  showTidio: false,
  enableStripeBilling: false,
  serviceName: "Yanair international center for languages",
  pwaServiceName: "Yanair Ai",
  appLogoPath: "/partner/yanair/logo.png",
  appLogoHeight: "140px",
  landingLogoPath: "/partner/yanair/logo.png",
  landingLogoHeight: "60px",
  hubLogoPath: "/partner/yanair/logo.png",
  hubLogoHeight: "60px",
  favicon: "/partner/yanair/icon.png",
  pwaIcons: [
    {
      src: "/partner/yanair/icon.png",
      type: "image/png",
      sizes: "192x192",
    },
  ],
  overrideLanding: true,
  emailsSender: "info@lang-services.com",
  adminEmail: "yanair@yanair.org",
  adminPhoneNumber: "+1 (214) 329-1530",
  whatsAppNumber: 12143291530,
  reviewLink: null,
  copyright: "Yanair international center for languages",
  showLanguageGuides: true,
  bioPrompt: `
You are a language tutor at Yanair
International Center for Languages, where we
make language learning both enjoyable and
practical. Our mission is to help you speak
confidently in everyday situations, with
lessons that adapt to your interests and
goals. Together, we’ll make speaking feel
effortless.
  `,
  siteColors: {
    special: {
      desktopSidebar: "#fff",
      desktopSidebarBorderColor: "#ddd",
      desktopSidebarText: "#000",
      desktopSidebarTextHover: "#eee",
      chatAsideMenu: "#333",
      mobileNavBackgroundColor: "#333",
      mobileNavBackgroundContrastColor: "#ffffff",
      mobileNavBorderColor: "#333",
      speakInputIdle: "var(--chakra-colors-brand-primary-700)",
      speakInputRecording: "var(--chakra-colors-brand-secondary-800)",
      speakInputRecordingCancel: "var(--chakra-colors-brand-secondary-900)",
    },
  },
  colors: {
    primary: {
      main: "#2e994d",
      mainContrast: "#fff",
      "50": "#f2f9f4",
      "100": "#cde6d4",
      "200": "#a0d1ae",
      "300": "#69b67f",
      "400": "#49a664",
      "500": "#2b8e48",
      "600": "#24783d",
      "700": "#1d6131",
      "800": "#195229",
      "900": "#123b1e",
    },
    secondary: {
      main: "#23336F",
      mainContrast: "#fff",
      "50": "#f7f7f9",
      "100": "#dde0e9",
      "200": "#c1c5d6",
      "300": "#9ea5c0",
      "400": "#8b93b3",
      "500": "#717ca2",
      "600": "#5c6894",
      "700": "#445285",
      "800": "#35447b",
      "900": "#202f67",
    },
    tertiary: {
      main: "#23336F",
      mainContrast: "#fff",
      "50": "#f7f7f9",
      "100": "#dde0e9",
      "200": "#c1c5d6",
      "300": "#9ea5c0",
      "400": "#8b93b3",
      "500": "#717ca2",
      "600": "#5c6894",
      "700": "#445285",
      "800": "#35447b",
      "900": "#202f67",
    },
  },
};
